import { Columns } from 'tabler-icons-react';
import {
  ECOM_ENTITY_TYPES,
  ECOM_WEBSTORE_SECTION_BOUND_TYPE,
  ECOM_WEBSTORE_SECTION_TYPE_ENUM,
  INPUT_CONTROL_TYPE_ENUM
} from '../../../../../config/constants';
import WsBreadcrumbs from './WsBreadcrumbs';

const configNameValues = {
  separator: 'separator',
  customSeparator: 'customSeparator',
  limitWidth: 'limitWidth',
  maxContainerWidth: 'maxContainerWidth',
  hideSinglePage: 'hideSinglePage',
  shortenLongTitles: 'shortenLongTitles',
  shortenLongTitleLength: 'shortenLongTitleLength',
  hideOnMobile: 'hideOnMobile',
  colorScheme: 'colorScheme'
};

const configDefaultValues = {
  [configNameValues.separator]: '/',
  [configNameValues.customSeparator]: '',
  [configNameValues.limitWidth]: 'false',
  [configNameValues.maxContainerWidth]: '800',
  [configNameValues.hideSinglePage]: 'false',
  [configNameValues.colorScheme]: '1',
  [configNameValues.shortenLongTitles]: 'true',
  [configNameValues.shortenLongTitleLength]: '300',
  [configNameValues.hideOnMobile]: 'false',
  topPadding: '12',
  bottomPadding: '12'
};

const configOptions = {
  [configNameValues.separator]: {
    label: 'Separator',
    type: INPUT_CONTROL_TYPE_ENUM.DROP_DOWN,
    options: [
      {
        value: '/',
        label: '/'
      },
      {
        value: '→',
        label: '→'
      },
      {
        value: '»',
        label: '»'
      },
      {
        value: '>',
        label: '>'
      },
      {
        value: '|',
        label: '|'
      },
      {
        value: '-',
        label: '-'
      },
      {
        value: '·',
        label: '·'
      },
      {
        value: '•',
        label: '•'
      },
      {
        value: '■',
        label: '■'
      },
      {
        value: '□',
        label: '□'
      },
      {
        value: 'custom',
        label: 'Custom'
      }
    ]
  },
  [configNameValues.customSeparator]: {
    label: 'Custom Separator',
    type: INPUT_CONTROL_TYPE_ENUM.TEXT_INPUT,
    isVisible: (config) => config[configNameValues.separator] === 'custom'
  },
  [configNameValues.hideSinglePage]: {
    label: 'Hide breadcrumbs on single path',
    description: 'Hide breadcrumbs when there’s only one path in the URL.',
    type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  [configNameValues.limitWidth]: {
    label: 'Limit width',
    description: 'Limit the width of the breadcrumbs container.',
    type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  [configNameValues.maxContainerWidth]: {
    label: 'Max container width',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 300,
    max: 1200,
    isVisible: (config) => config.limitWidth === 'true'
  },
  [configNameValues.shortenLongTitles]: {
    label: 'Shorten long titles',
    type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  [configNameValues.shortenLongTitleLength]: {
    label: 'Max title length (px)',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 100,
    max: 600,
    isVisible: (config) => config.shortenLongTitles === 'true'
  },
  [configNameValues.hideOnMobile]: {
    label: 'Hide on mobile',
    type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  [configNameValues.colorScheme]: {
    label: 'Color scheme',
    type: 'entity',
    entityType: ECOM_ENTITY_TYPES.ecomStoreThemeColorScheme
  }
};

const config = {
  type: ECOM_WEBSTORE_SECTION_TYPE_ENUM.BREADCRUMBS,
  title: 'Breadcrumbs',
  icon: Columns,
  allowedBounds: [
    ECOM_WEBSTORE_SECTION_BOUND_TYPE.HEADER,
    ECOM_WEBSTORE_SECTION_BOUND_TYPE.BODY
  ],
  Component: WsBreadcrumbs,
  configOptions,
  maxItemCount: null,
  blocks: [],
  defaultConfig: configDefaultValues
};

export { config, configOptions, configNameValues, configDefaultValues };
